import SEOHead from "@/components/General/SEOHead";
import Volunteer from "@/modules/Volunteer/Volunteer";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

const VolunteerPage = () => {
  return (
    <>
      <SEOHead />
      <Volunteer />
    </>
  );
};

export const getServerSideProps = async ({ locale }: any) => ({
  props: {
    ...(await serverSideTranslations(locale, ["common"])),
  },
});

export default VolunteerPage;
